import styled from 'styled-components';
export const StyledContainer = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4.1rem;
`;
export const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
`;
export const StyledTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
  text-align: center;

  h1 {
    margin: 0;
  }
`;
export const StyledTitle = styled.h1`
  font-family: ${({
  theme
}) => theme.fonts.familyUbuntu};
  font-size: ${({
  theme
}) => theme.fonts.sizes.subTitle};
`;
export const StyledDescription = styled.p`
  font-family: ${({
  theme
}) => theme.fonts.familySansPro};
  font-size: ${({
  theme
}) => theme.fonts.sizes.default};
`;